import ScrollReveal from "@/components/base/ScrollReveal";

const trustItems = [
  {
    icon: "ri-computer-line",
    title: "Telehealth across New York, New Jersey, and Indiana",
    desc: "Secure, private video sessions from wherever you are in the state.",
    iconColor: "#7D54FC",
    iconBg: "rgba(125,84,252,0.09)",
    topBar: "linear-gradient(90deg, #7D54FC, #B4A6E3)",
  },
  {
    icon: "ri-building-line",
    title: "In-person sessions available in Larchmont",
    desc: "Prefer face-to-face? Our Larchmont office is open for in-person sessions.",
    iconColor: "#3C6FF8",
    iconBg: "rgba(60,111,248,0.09)",
    topBar: "linear-gradient(90deg, #3C6FF8, #7D54FC)",
  },
  {
    icon: "ri-money-dollar-circle-line",
    title: "Clear, transparent self-pay",
    desc: "Upfront rates. No surprise bills. Clear self-pay and out-of-network support.",
    iconColor: "#7D54FC",
    iconBg: "rgba(180,166,227,0.18)",
    topBar: "linear-gradient(90deg, #B4A6E3, #7D54FC)",
  },
];

export default function TrustIndicators() {
  return (
    <section
      className="w-full py-12 md:py-16"
      style={{ background: "linear-gradient(180deg, #FBF9F6 0%, #F5F1E8 50%, #F8F5EE 100%)" }}
    >
      <div className="w-full px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6">
          {trustItems.map((item, i) => (
            <ScrollReveal key={item.title} variant="fadeUp" delay={i * 90}>
              <div
                className="bg-white border rounded-2xl overflow-hidden h-full card-hover cursor-default"
                style={{ borderColor: item.iconColor + "20" }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLDivElement).style.borderColor = item.iconColor + "45";
                  (e.currentTarget as HTMLDivElement).style.background = "rgba(255,255,255,1)";
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLDivElement).style.borderColor = item.iconColor + "20";
                  (e.currentTarget as HTMLDivElement).style.background = "";
                }}
              >
                {/* Gradient top accent bar */}
                <div className="h-[3px] w-full" style={{ background: item.topBar }} />
                <div className="p-6 md:p-7">
                  <div
                    className="w-10 h-10 flex items-center justify-center rounded-xl mb-5"
                    style={{ backgroundColor: item.iconBg }}
                  >
                    <i className={`${item.icon} text-lg`} style={{ color: item.iconColor }}></i>
                  </div>
                  <h3 className="font-fraunces text-[#2B2B2B] text-lg font-medium mb-2 leading-snug">
                    {item.title}
                  </h3>
                  <p className="font-manrope text-[#2B2B2B]/78 text-[15px] leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
